// extracted by mini-css-extract-plugin
export default {"user_menu_item":"UserButton_user_menu_item__KBIt9","name":"UserButton_name__iUC3u","avatar":"UserButton_avatar__V1n3x"};